/**
 * Двое, кому видна «Админка». Не staff: куратор ленту видит, стол — нет.
 * Те же номера, что `backend/forq/access/owners.py`.
 *
 * Смотрим и поле `owner` с шлюза, и id: старый шлюз поля ещё не отдаёт,
 * и без проверки id владельца выкидывало на главную.
 */

export const OWNER_IDS = new Set(['7206873220', '8030661704']);

export function isOwner(me: { owner?: boolean; id?: string | null }): boolean {
  if (me.owner === true) return true;
  return typeof me.id === 'string' && OWNER_IDS.has(me.id);
}
